import React, { useState, useEffect } from 'react';
import './addNewCar.css';

const AddNewCar = () => {
  const [step, setStep] = useState(1);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [categorySearch, setCategorySearch] = useState('');
  const [brandSearch, setBrandSearch] = useState('');
  const [showAddColorDialog, setShowAddColorDialog] = useState(false);
  const [newColor, setNewColor] = useState('');
  const [tempAccessory, setTempAccessory] = useState('');
  const [showAccessoryButtons, setShowAccessoryButtons] = useState(false);
  const [moreAccessories, setMoreAccessories] = useState([]);
  const [newMoreAccessory, setNewMoreAccessory] = useState('');
  const [validationError, setValidationError] = useState(null);
  const [showSubmitSuccessPopup, setShowSubmitSuccessPopup] = useState(false);
  const [selectedShippingOption, setSelectedShippingOption] = useState(null);
  const [portFeeConfigs, setPortFeeConfigs] = useState([]);
  const [shippingFees, setShippingFees] = useState({
    CIF: {},
    CNF: {},
    FOB: {}
  });
  const [isEditing, setIsEditing] = useState({});
  const [editedFields, setEditedFields] = useState(new Set());


  // Get all unique fee types across all configurations
const getAllUniqueFees = () => {
  const allFees = new Set();
  portFeeConfigs.forEach(config => {
    config.feeConfigurationList.forEach(fee => {
      allFees.add(fee);
    });
  });
  return Array.from(allFees);
};

// Check which shipping options have a specific fee
const getShippingOptionsForFee = (feeType) => {
  return portFeeConfigs.filter(config => 
    config.feeConfigurationList.includes(feeType)
  );
};

// Format fee name for display
const formatFeeLabel = (feeType) => {
  return feeType.replace(/_/g, ' ');
};

  const handleShippingOptionChange = (option) => {
    setSelectedShippingOption(option);
  };

  const fetchPortFeeConfigs = async () => {
    try {
      const response = await fetch('https://car.amar.co.jp/api/authorization/admin-shipment-panel/get-all-port-fee-config', {
        method: 'GET',
        headers: {
          'accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch port fee configurations');
      }

      const data = await response.json();
      setPortFeeConfigs(data);

      // Initialize shipping fees based on API response
      const initialFees = {
        CIF: {},
        CNF: {},
        FOB: {}
      };

      data.forEach(config => {
        if (config.shippingOptionName === 'CIF') {
          initialFees.CIF = config.feeConfigurationList.reduce((acc, fee) => {
            acc[fee] = '';
            return acc;
          }, {});
        } else if (config.shippingOptionName === 'CNF') {
          initialFees.CNF = config.feeConfigurationList.reduce((acc, fee) => {
            acc[fee] = '';
            return acc;
          }, {});
        } else if (config.shippingOptionName === 'FOB') {
          initialFees.FOB = config.feeConfigurationList.reduce((acc, fee) => {
            acc[fee] = '';
            return acc;
          }, {});
        }
      });

      setShippingFees(initialFees);
    } catch (err) {
      console.error('Error fetching port fee configurations:', err);
    }
  };

  // const handleShippingFeeChange = (option, field, value) => {
  //   setShippingFees(prev => ({
  //     ...prev,
  //     [option]: {
  //       ...prev[option],
  //       [field]: value
  //     }
  //   }));
  // };
//   const handleShippingFeeChange = (shippingOption, feeType, value) => {
//   setShippingFees(prev => {
//     const updated = { ...prev };
    
//     // Get all shipping options that have this fee type
//     const optionsWithThisFee = getShippingOptionsForFee(feeType);
    
//     // Update the value for all shipping options that have this fee type
//     optionsWithThisFee.forEach(config => {
//       if (!updated[config.shippingOptionName]) {
//         updated[config.shippingOptionName] = {};
//       }
//       updated[config.shippingOptionName][feeType] = value;
//     });
    
//     return updated;
//   });
// };
// const handleShippingFeeChange = (shippingOption, feeType, value) => {
//   setShippingFees(prev => {
//     const updated = { ...prev };
    
//     // Get all shipping options that have this fee type
//     const optionsWithThisFee = getShippingOptionsForFee(feeType);
    
//     // ❌ Problem: Updating ALL options that contain this fee
//     optionsWithThisFee.forEach(config => {
//       if (!updated[config.shippingOptionName]) {
//         updated[config.shippingOptionName] = {};
//       }
//       updated[config.shippingOptionName][feeType] = value;
//     });
    
//     return updated;
//   });
// };
const handleShippingFeeChange = (shippingOption, feeType, value) => {
  const fieldKey = `${shippingOption}-${feeType}`;
  
  setShippingFees(prev => {
    const updated = { ...prev };
    
    // Check if any field of this fee type has been individually edited
    const hasBeenEdited = Array.from(editedFields).some(key => key.endsWith(`-${feeType}`));
    
    if (!hasBeenEdited) {
      // First time filling this fee type - copy to all applicable options
      const optionsWithThisFee = getShippingOptionsForFee(feeType);
      
      optionsWithThisFee.forEach(config => {
        if (!updated[config.shippingOptionName]) {
          updated[config.shippingOptionName] = {};
        }
        updated[config.shippingOptionName][feeType] = value;
      });
    } else {
      // This fee type has been edited before - only update the specific field
      if (!updated[shippingOption]) {
        updated[shippingOption] = {};
      }
      updated[shippingOption][feeType] = value;
    }
    
    return updated;
  });
};

const handleFeeInputFocus = (shippingOption, feeType) => {
  const fieldKey = `${shippingOption}-${feeType}`;
  
  // Only mark as edited if the field already has a value
  if (shippingFees[shippingOption]?.[feeType]) {
    setEditedFields(prev => new Set([...prev, fieldKey]));
  }
};

const handleFeeInputBlur = (shippingOption, feeType) => {
  const editingKey = `${shippingOption}-${feeType}`;
  // Remove editing state after a short delay to allow for rapid typing
  setTimeout(() => {
    setIsEditing(prev => {
      const updated = { ...prev };
      delete updated[editingKey];
      return updated;
    });
  }, 500);
};

  const handleSaveShippingFees = () => {
    // Here you can save the fees to your form data or API
    console.log('Shipping fees saved:', shippingFees);
    // Show success message or perform other actions
  };

  const [uploadState, setUploadState] = useState({
    showUploadDialog: false,
    currentUpload: null,
    isUploading: false,
    uploadError: null
  });

  const [loading, setLoading] = useState({
    categories: true,
    brands: true,
    step2Data: false,
    apiCall: false
  });

  const [error, setError] = useState({
    categories: null,
    brands: null,
    step2Data: null,
    apiCall: null
  });

  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessPopupMoreAccessories, setShowSuccessPopupMoreAccessories] = useState(false);

  // State for API data
  const [apiData, setApiData] = useState({
    engineCCRanges: [],
    fuels: [],
    transmissions: [],
    steeringOptions: [],
    seatRanges: [],
    mileageRanges: [],
    colors: [],
    vehicleAccessories: [],
    priceRanges: [],
    driveType: []
  });

  const [formData, setFormData] = useState({
    category: '',
    brand: '',
    model: '',
    priceRange: '',
    price: '',
    year: '',
    refNumber: '',
    registrationDate: '',
    manufactureDate: '',
    modelCode: '',
    grade: '',
    chassisNumber: '',
    engineCCRange: '',
    engineCC: '',
    engineCode: '',
    fuel: '',
    transmission: '',
    steering: '',
    seatRange: '',
    seat: '',
    doors: '',
    mileageRange: '',
    mileage: '',
    color: '',
    weight: '',
    drive: '',
    location: '',
    length: '',
    width: '',
    height: '',
    ourPick: false,
    specialDeal: false,
    airConditioning: '',
    vehicleAccessories: [],
    moreAccessories: [],
    savedAccessories: [],
    modelDescription: '',
    exteriorImages: Array(15).fill(null),
    interiorImages: Array(15).fill(null),
    blueprintImage: null
  });

  const validateImage = (file) => {
    // Check file type
    const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      alert('Please upload a JPG or PNG image');
      return false;
    }

    // Check file size (2MB max)
    if (file.size > 2 * 1024 * 1024) {
      alert('Image must be less than 2MB');
      return false;
    }

    return true;
  };

  const showUploadConfirmation = (type, index, file) => {
    setUploadState({
      showUploadDialog: true,
      currentUpload: { type, index, file },
      isUploading: false,
      uploadError: null
    });
  };

  const handleUploadConfirm = async () => {
    if (!uploadState.currentUpload || !apiResponse?.carModelId) return;

    const { type, index, file } = uploadState.currentUpload;
    const carModelId = apiResponse.carModelId;

    setUploadState(prev => ({ ...prev, isUploading: true }));

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('image', file);

      let endpoint = '';
      if (type === 'exterior') {
        endpoint = `car-exterior-images-${index + 1}`;
      } else if (type === 'interior') {
        endpoint = `car-interior-images-${index + 1}`;
      } else if (type === 'blueprint') {
        endpoint = 'car-exterior-images-16';
      }

      const response = await fetch(
        `https://car.amar.co.jp/api/image/${endpoint}/upload-image/${carModelId}`,
        {
          method: 'POST',
          headers: {
            'Accept-Language': 'en',
            'Accept': '*/*'
          },
          body: formDataToSend
        }
      );

      if (!response.ok) {
        throw new Error('Failed to upload image');
      }

      // Update preview and form data
      if (type === 'blueprint') {
        setPreviewImages(prev => ({
          ...prev,
          blueprint: URL.createObjectURL(file)
        }));
        setFormData(prev => ({
          ...prev,
          blueprintImage: file
        }));
      } else {
        const newPreviews = [...previewImages[type]];
        newPreviews[index] = URL.createObjectURL(file);
        setPreviewImages(prev => ({
          ...prev,
          [type]: newPreviews
        }));

        const newImages = [...formData[`${type}Images`]];
        newImages[index] = file;
        setFormData(prev => ({
          ...prev,
          [`${type}Images`]: newImages
        }));
      }

      // Close dialog
      setUploadState({
        showUploadDialog: false,
        currentUpload: null,
        isUploading: false,
        uploadError: null
      });

    } catch (err) {
      console.error('Error uploading image:', err);
      setUploadState(prev => ({
        ...prev,
        isUploading: false,
        uploadError: err.message
      }));
    }
  };

  const handleUploadCancel = () => {
    setUploadState({
      showUploadDialog: false,
      currentUpload: null,
      isUploading: false,
      uploadError: null
    });
  };

  const filteredCategories = categories.filter(category =>
    category.toLowerCase().includes(categorySearch.toLowerCase())
  );

  const filteredBrands = brands.filter(brand =>
    brand.toLowerCase().includes(brandSearch.toLowerCase())
  );

  const fetchMoreAccessories = async () => {
    try {
      const response = await fetch('https://car.amar.co.jp/api/dashboard/car-more-accessories/get-all-more-accessories', {
        headers: {
          'accept': 'application/json',
          'Accept-Language': 'en'
        }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch more accessories');
      }
      const data = await response.json();
      setMoreAccessories(data.map(item => item.carMoreAccessories));
    } catch (err) {
      console.error('Error fetching more accessories:', err);
    }
  };

  useEffect(() => {
    // Fetch categories
    fetch('https://car.amar.co.jp/api/master/car-catgories/get-all-categories', {
      method: 'GET',
      headers: {
        'accept': 'application/json',
        'Accept-Language': 'en'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch categories');
        }
        return response.json();
      })
      .then(data => {
        // Check if data is an array or has a different structure
        const categoriesData = Array.isArray(data) ? data : (data.data || []);
        setCategories(categoriesData.map(item => item.categoriesName || item.name || item));
        setLoading(prev => ({ ...prev, categories: false }));
      })
      .catch(err => {
        console.error('Error fetching categories:', err);
        setError(prev => ({ ...prev, categories: err.message }));
        setLoading(prev => ({ ...prev, categories: false }));
      });

    // Fetch brands
    fetch('https://car.amar.co.jp/api/master/car-brand/get-all-brandName', {
      method: 'GET',
      headers: {
        'accept': 'application/json',
        'Accept-Language': 'en'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch brands');
        }
        return response.json();
      })
      .then(carBrandList => {
        const brandsData = Array.isArray(carBrandList) ? carBrandList : (carBrandList.carBrandList || []);
        setBrands(brandsData.map(item => {
          const brandName = item.carBrandName || item.name || item;
          return brandName.charAt(0).toUpperCase() + brandName.slice(1);
        }));
        setLoading(prev => ({ ...prev, brands: false }));
      })
      .catch(err => {
        console.error('Error fetching brands:', err);
        setError(prev => ({ ...prev, brands: err.message }));
        setLoading(prev => ({ ...prev, brands: false }));
      });
  }, []);

  // Fetch step 2 data when step changes to 2
  useEffect(() => {
    if (step === 2 && apiData.engineCCRanges.length === 0) {
      fetchStep2Data();
      fetchMoreAccessories();
      fetchPortFeeConfigs();
    }
  }, [step]);

  const handleSaveMoreAccessory = async () => {
    if (!newMoreAccessory.trim()) return;

    try {
      const response = await fetch(
        `https://car.amar.co.jp/api/dashboard/car-more-accessories/save?moreAccessoriesName=${encodeURIComponent(newMoreAccessory)}`,
        {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Accept-Language': 'en'
          }
        }
      );

      if (!response.ok) {
        throw new Error('Failed to save accessory');
      }

      const data = await response.json();
      setNewMoreAccessory('');
      fetchMoreAccessories();
      if (response) {
        setShowSuccessPopupMoreAccessories(true);
        const timer = setTimeout(() => {
          setShowSuccessPopupMoreAccessories(false);
        }, 2000);
        return () => clearTimeout(timer);
      }
    } catch (err) {
      console.error('Error saving accessory:', err);
    }
  };

  // Show success popup for 2 seconds when apiResponse changes
  useEffect(() => {
    if (apiResponse) {
      setShowSuccessPopup(true);
      const timer = setTimeout(() => {
        setShowSuccessPopup(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [apiResponse]);

  const fetchStep2Data = async () => {
    setLoading(prev => ({ ...prev, step2Data: true }));
    setError(prev => ({ ...prev, step2Data: null }));

    try {
      // Define all API endpoints
      const endpoints = [
        {
          url: 'https://car.amar.co.jp/api/dashboard/car-engine/get-all-engine-cc-range',
          key: 'engineCCRanges',
          field: 'carEngineRange'
        },
        {
          url: 'https://car.amar.co.jp/api/dashboard/car-fuel-type/get-all-fuel-type',
          key: 'fuels',
          field: 'carFuelType'
        },
        {
          url: 'https://car.amar.co.jp/api/dashboard/car-transmission/get-all-transmission-type',
          key: 'transmissions',
          field: 'carTransmission'
        },
        {
          url: 'https://car.amar.co.jp/api/dashboard/car-steering/get-all-steering-type',
          key: 'steeringOptions',
          field: 'carSteering'
        },
        {
          url: 'https://car.amar.co.jp/api/dashboard/car-seat/get-all-seat',
          key: 'seatRanges',
          field: 'carSeatRange'
        },
        {
          url: 'https://car.amar.co.jp/api/dashboard/car-mileage/get-all-mileage-range',
          key: 'mileageRanges',
          field: 'carMileageRange'
        },
        {
          url: 'https://car.amar.co.jp/api/dashboard/car-color/get-all-color',
          key: 'colors',
          field: 'carColor'
        },
        {
          url: 'https://car.amar.co.jp/api/dashboard/car-filter-accessories/get-all-filter-accessories',
          key: 'vehicleAccessories',
          field: 'carFilterAccessories'
        },
        {
          url: 'https://car.amar.co.jp/api/dashboard/car-price/get-all-price-range',
          key: 'priceRanges',
          field: 'carPriceRange'
        },
        {
          url: 'https://car.amar.co.jp/api/dashboard/car-drive-type/get-all-drive-type',
          key: 'driveType',
          field: 'carDriveType'
        }
      ];

      // Fetch all data in parallel
      const results = await Promise.all(
        endpoints.map(async ({ url, key, field }) => {
          const response = await fetch(url, {
            headers: {
              'accept': 'application/json',
              'Accept-Language': 'en'
            }
          });
          if (!response.ok) {
            throw new Error(`Failed to fetch ${key}`);
          }
          const data = await response.json();
          return { key, data: data.map(item => item[field]) };
        })
      );

      // Update state with all fetched data
      const newData = results.reduce((acc, { key, data }) => {
        acc[key] = data;
        return acc;
      }, {});

      setApiData(prev => ({
        ...prev,
        ...newData
      }));
    } catch (err) {
      console.error('Error fetching step 2 data:', err);
      setError(prev => ({ ...prev, step2Data: err.message }));
    } finally {
      setLoading(prev => ({ ...prev, step2Data: false }));
    }
  };

  const handleAddColorClick = () => {
    setShowAddColorDialog(true);
  };

  const handleSaveNewColor = async () => {
    if (!newColor.trim()) {
      alert('Please enter a color name');
      return;
    }

    try {
      setLoading(prev => ({ ...prev, apiCall: true }));

      // Call API to add new color (POST request)
      const response = await fetch(
        `https://car.amar.co.jp/api/dashboard/car-color/add-new-color?colorName=${encodeURIComponent(newColor)}`,
        {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Accept-Language': 'en'
          },
          body: ''
        }
      );

      if (!response.ok) {
        throw new Error('Failed to add color');
      }

      const data = await response.json();

      // Call GET API to fetch all colors
      const colorsResponse = await fetch('https://car.amar.co.jp/api/dashboard/car-color/get-all-color', {
        headers: {
          'accept': 'application/json',
          'Accept-Language': 'en'
        }
      });

      if (!colorsResponse.ok) {
        throw new Error('Failed to fetch colors');
      }

      const colorsData = await colorsResponse.json();

      // Update state with new colors list
      setApiData(prev => ({
        ...prev,
        colors: colorsData.map(item => item.carColor)
      }));

      // Show success popup
      setShowSuccessPopup(true);

      // Close dialog and reset
      setShowAddColorDialog(false);
      setNewColor('');

      // Hide success popup after 2 seconds
      setTimeout(() => {
        setShowSuccessPopup(false);
      }, 2000);

    } catch (err) {
      console.error('Error adding color:', err);
      alert('Failed to add color: ' + err.message);
    } finally {
      setLoading(prev => ({ ...prev, apiCall: false }));
    }
  };

  const handleCancelAddColor = () => {
    setShowAddColorDialog(false);
    setNewColor('');
  };

  // Helper functions to determine ranges
  const getPriceRange = (price) => {
    if (!price) return '';
    const priceNum = parseFloat(price);
    if (priceNum <= 1000) return '$0-$1000';
    if (priceNum <= 2000) return '$1001-$2000';
    if (priceNum <= 3000) return '$2001-$3000';
    if (priceNum <= 4000) return '$3001-$4000';
    if (priceNum <= 5000) return '$4001-$5000';
    if (priceNum <= 6000) return '$5001-$6000';
    if (priceNum <= 7000) return '$6001-$7000';
    if (priceNum <= 8000) return '$7001-$8000';
    if (priceNum <= 9000) return '$8001-$9000';
    if (priceNum <= 10000) return '$9001-$10000';
    return '$10001_ABOVE';
  };

  const getEngineCCRange = (cc) => {
    if (!cc) return '';
    const ccNum = parseInt(cc);
    if (ccNum <= 500) return '0CC-500CC';
    if (ccNum <= 1000) return '501CC-1000CC';
    if (ccNum <= 1500) return '1001CC-1500CC';
    if (ccNum <= 2000) return '1501CC-2000CC';
    if (ccNum <= 2500) return '2001CC-2500CC';
    if (ccNum <= 3000) return '2501CC-3000CC';
    return '3001CC_ABOVE';
  };

  const getSeatRange = (seats) => {
    if (!seats) return '';
    const seatsNum = parseInt(seats);
    if (seats == 1) return '1';
    if (seats == 2) return '2';
    if (seats == 3) return '3';
    if (seats == 4) return '4';
    if (seats == 5) return '5';
    if (seats == 6) return '6';
    if (seats == 7) return '7';
    return '8_ABOVE';
  };

  const getMileageRange = (mileage) => {
    if (!mileage) return '';
    const mileageNum = parseInt(mileage);
    if (mileageNum <= 5000) return '0KM-5000KM';
    if (mileageNum <= 10000) return '5001KM-10000KM';
    if (mileageNum <= 20000) return '10001KM-20000KM';
    if (mileageNum <= 30000) return '20001KM-30000KM';
    if (mileageNum <= 40000) return '30001KM-40000KM';
    if (mileageNum <= 50000) return '40001KM-50000KM';
    return '50001KM_ABOVE';
  };

  const getCategoryIcon = (category) => {
    const icons = {
      'SEDAN': '🚗',
      'SUV': '🚙',
      'TRUCK': '🛻',
      'SPORTS': '🏎️',
      'LUXURY': '✨',
      'ELETRIC': '⚡',
      'HATCHBACK': '🚘',
      'CONVERTIBLE': '🔃'
    };
    return icons[category] || '🚘';
  };

  const [previewImages, setPreviewImages] = useState({
    exterior: Array(15).fill(null),
    interior: Array(15).fill(null),
    blueprint: null
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData(prev => {
      const newData = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      };

      // Automatically update ranges based on input values
      if (name === 'price') {
        newData.priceRange = getPriceRange(value);
      } else if (name === 'engineCC') {
        newData.engineCCRange = getEngineCCRange(value);
      } else if (name === 'seat') {
        newData.seatRange = getSeatRange(value);
      } else if (name === 'mileage') {
        newData.mileageRange = getMileageRange(value);
      }

      return newData;
    });
  };

  const handleAccessoriesChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const newAccessories = checked
        ? [...prev.vehicleAccessories, value]
        : prev.vehicleAccessories.filter(item => item !== value);
      return {
        ...prev,
        vehicleAccessories: newAccessories
      };
    });
  };

  const handleMoreAccessoriesChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const newMoreAccessories = checked
        ? [...prev.moreAccessories, value]
        : prev.moreAccessories.filter(item => item !== value);
      return {
        ...prev,
        moreAccessories: newMoreAccessories
      };
    });
  };

  const handleImageUpload = (type, index, e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Reset file input to allow selecting the same file again
    e.target.value = '';

    if (!validateImage(file)) {
      return;
    }

    showUploadConfirmation(type, index, file);
  };
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   if (type === 'exterior') {
  //     const newExteriorImages = [...formData.exteriorImages];
  //     newExteriorImages[index] = file;
  //     setFormData(prev => ({
  //       ...prev,
  //       exteriorImages: newExteriorImages
  //     }));

  //     const newPreviews = [...previewImages.exterior];
  //     newPreviews[index] = URL.createObjectURL(file);
  //     setPreviewImages(prev => ({
  //       ...prev,
  //       exterior: newPreviews
  //     }));
  //   }
  //   else if (type === 'interior') {
  //     const newInteriorImages = [...formData.interiorImages];
  //     newInteriorImages[index] = file;
  //     setFormData(prev => ({
  //       ...prev,
  //       interiorImages: newInteriorImages
  //     }));

  //     const newPreviews = [...previewImages.interior];
  //     newPreviews[index] = URL.createObjectURL(file);
  //     setPreviewImages(prev => ({
  //       ...prev,
  //       interior: newPreviews
  //     }));
  //   }
  //   else if (type === 'blueprint') {
  //     setFormData(prev => ({
  //       ...prev,
  //       blueprintImage: file
  //     }));

  //     setPreviewImages(prev => ({
  //       ...prev,
  //       blueprint: URL.createObjectURL(file)
  //     }));
  //   }
  // };

  const removeImage = (type, index) => {
    if (type === 'exterior') {
      const newExteriorImages = [...formData.exteriorImages];
      newExteriorImages[index] = null;
      setFormData(prev => ({
        ...prev,
        exteriorImages: newExteriorImages
      }));

      const newPreviews = [...previewImages.exterior];
      URL.revokeObjectURL(newPreviews[index]);
      newPreviews[index] = null;
      setPreviewImages(prev => ({
        ...prev,
        exterior: newPreviews
      }));
    }
    else if (type === 'interior') {
      const newInteriorImages = [...formData.interiorImages];
      newInteriorImages[index] = null;
      setFormData(prev => ({
        ...prev,
        interiorImages: newInteriorImages
      }));

      const newPreviews = [...previewImages.interior];
      URL.revokeObjectURL(newPreviews[index]);
      newPreviews[index] = null;
      setPreviewImages(prev => ({
        ...prev,
        interior: newPreviews
      }));
    }
    else if (type === 'blueprint') {
      setFormData(prev => ({
        ...prev,
        blueprintImage: null
      }));

      URL.revokeObjectURL(previewImages.blueprint);
      setPreviewImages(prev => ({
        ...prev,
        blueprint: null
      }));
    }
  };

  const validateStep2Form = () => {
    const requiredFields = [
      'model', 'priceRange', 'price', 'year', 'refNumber', 'registrationDate',
      'manufactureDate', 'modelCode', 'grade', 'chassisNumber', 'engineCCRange',
      'engineCC', 'engineCode', 'fuel', 'transmission', 'steering', 'seatRange',
      'seat', 'doors', 'mileageRange', 'mileage', 'color', 'weight', 'drive',
      'location', 'length', 'width', 'height', 'airConditioning'
    ];

    let isValid = true;

    // Check if all required fields are filled
    requiredFields.forEach(field => {
      if (!formData[field]) {
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationError('Please fill in all required fields');

      // Highlight empty fields
      requiredFields.forEach(field => {
        const element = document.getElementById(field);
        if (element) {
          if (!formData[field]) {
            element.style.borderColor = '#d10000';
            element.style.boxShadow = '0 0 0 2px rgba(209, 0, 0, 0.1)';
          } else {
            element.style.borderColor = '#ddd';
            element.style.boxShadow = 'none';
          }
        }
      });

      // Scroll to the first error
      const firstErrorField = requiredFields.find(field => !formData[field]);
      if (firstErrorField) {
        const element = document.getElementById(firstErrorField);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      return false;
    }

    // Clear error if all fields are valid
    setValidationError(null);
    return true;
  };

  const callAddCarModelAPI = async () => {
    setLoading(prev => ({ ...prev, apiCall: true }));
    setError(prev => ({ ...prev, apiCall: null }));

    try {
      // Create shippingFeeConfig array based on portFeeConfigs and shippingFees
      const shippingFeeConfig = portFeeConfigs.map(config => {
        return {
          shippingOption: config.shippingOptionName,
          feeConfigs: config.feeConfigurationList.map(fee => {
            return {
              feeConfig: fee,
              feeConfigAmount: parseFloat(shippingFees[config.shippingOptionName][fee]) || 0
            };
          })
        };
      });

      const requestBody = {
        carCategories: formData.category,
        carBrand: formData.brand,
        carModelName: formData.model,
        carPriceRange: formData.priceRange,
        carPrice: parseFloat(formData.price),
        carYear: parseInt(formData.year),
        carReferenceNumber: parseInt(formData.refNumber),
        carRegistrationDate: formData.registrationDate,
        carManufactureDate: formData.manufactureDate,
        carModelCode: formData.modelCode,
        carGrade: formData.grade,
        carChassisNumber: formData.chassisNumber,
        carEngineCCRange: formData.engineCCRange,
        carEngineCC: parseInt(formData.engineCC),
        carEngineCode: formData.engineCode,
        carFuelType: formData.fuel,
        carTransmission: formData.transmission,
        carSteering: formData.steering,
        carSeatRange: formData.seatRange,
        carSeats: parseInt(formData.seat),
        carDoors: parseInt(formData.doors),
        carMileageRange: formData.mileageRange,
        carMileage: parseInt(formData.mileage),
        carColor: formData.color,
        carDrive: formData.drive,
        carLocation: formData.location,
        carLength: parseFloat(formData.length),
        carHeight: parseFloat(formData.height),
        carWidth: parseFloat(formData.width),
        ourPick: formData.ourPick,
        specialDeal: formData.specialDeal,
        airConditioning: formData.airConditioning,
        moreAccessories: formData.moreAccessories,
        vehicleMainAccessories: formData.vehicleAccessories,
        weight: parseFloat(formData.weight),
        modelDescription: formData.modelDescription,
        shippingFeeConfig: shippingFeeConfig
      };

      const response = await fetch('https://car.amar.co.jp/api/authorization/admin-car-panel/add-new-car-model', {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error('Failed to add car model');
      }

      const data = await response.json();
      setApiResponse(data);
      return data;
    } catch (err) {
      console.error('Error adding car model:', err);
      setError(prev => ({ ...prev, apiCall: err.message }));
      throw err;
    } finally {
      setLoading(prev => ({ ...prev, apiCall: false }));
    }
  };

  const handleSaveConfirm = async () => {
    setShowSaveDialog(false);
    try {
      await callAddCarModelAPI();
      setStep(3);
    } catch (err) {
      alert('Failed to save car model: ' + err.message);
    }
  };

  useEffect(() => {
    if (validationError) {
      // Revalidate when form data changes
      validateStep2Form();
    }
  }, [formData]);

  const nextStep = () => {
    if (step === 1) {
      if (!formData.category || !formData.brand) {
        alert('Please select both category and brand before proceeding');
        return;
      }
      setStep(prev => prev + 1);
    } else if (step === 2) {
      if (showAccessoryButtons) {
        alert('Please save or cancel the accessory you are currently adding before proceeding');
        return;
      }
      if (!validateStep2Form()) {
        return;
      }
      setShowSaveDialog(true);
    }
  };

  const prevStep = () => {
    setStep(prev => prev - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Show success popup
      setShowSubmitSuccessPopup(true);

      // After 2 seconds, redirect to step 1 and hide popup
      setTimeout(() => {
        setStep(1);
        setShowSubmitSuccessPopup(false);

        // Reset form if needed
        // setFormData({...initialFormState});
      }, 2000);

    } catch (err) {
      console.error('Error submitting vehicle:', err);
      alert('Failed to submit vehicle: ' + err.message);
    }
  };

  const renderStepIndicator = () => {
    return (
      <div className="step-indicator">
        {[1, 2, 3].map((num) => (
          <React.Fragment key={num}>
            <div className={`step-circle ${step === num ? 'active' : ''}`}>
              {num}
            </div>
            {num < 3 && <div className="step-line"></div>}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <div className="add-new-car">
      {/* Color Success Popup */}
      {showSuccessPopup && (
        <div className="success-popup-add-new-car">
          <div className="success-popup-content-add-new-car">
            <h3>Color Added Successfully!</h3>
            <p>The new color has been saved.</p>
          </div>
        </div>
      )}

      {showSuccessPopupMoreAccessories && (
        <div className="success-popup-add-new-car">
          <div className="success-popup-content-add-new-car">
            <h3>More Accessories Added Successfully!</h3>
            <p>The new accessories has been saved.</p>
          </div>
        </div>
      )}

      {step === 2 && validationError && (
        <div className="form-error-message" style={{
          color: '#d10000',
          margin: '10px 0',
          textAlign: 'center'
        }}>
          {validationError}
        </div>
      )}

      {showSubmitSuccessPopup && (
        <div className="success-popup-add-new-car">
          <div className="success-popup-content-add-new-car">
            <h3>Car Model and Images Added Successfully!</h3>
            <p>The vehicle has been successfully submitted.</p>
          </div>
        </div>
      )}

      <div className="form-header">
        <h2>Add New Vehicle</h2>
        {renderStepIndicator()}
      </div>

      <form onSubmit={handleSubmit} className="car-form">
        {step === 1 && (
          <div className="form-step active">
            {/* Category Selection */}
            <div className="selection-cards">
              <div className="search-header">
                <h3 className="h3-add-new-car">Select Category</h3>
                <div className="search-container">
                  <input
                    type="text"
                    placeholder="Search categories..."
                    value={categorySearch}
                    onChange={(e) => setCategorySearch(e.target.value)}
                    className="search-input"
                  />
                </div>
              </div>
              {loading.categories ? (
                <div className="loading-message">Loading categories...</div>
              ) : error.categories ? (
                <div className="error-message">Error loading categories: {error.categories}</div>
              ) : (
                <div className="card-grid">
                  {filteredCategories.map(category => (
                    <label
                      key={category}
                      className={`selection-card ${formData.category === category ? 'selected' : ''}`}
                    >
                      <input
                        type="radio"
                        name="category"
                        value={category}
                        checked={formData.category === category}
                        onChange={handleChange}
                        required
                      />
                      <div className="card-content">
                        <div className="card-front">
                          <div className="card-icon">
                            {getCategoryIcon(category)}
                          </div>
                          <span>{category}</span>
                        </div>
                        <div className="card-back">
                          <span>{category}</span>
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              )}
            </div>

            {/* Brand Selection */}
            <div className="selection-cards">
              <div className="search-header">
                <h3 className="h3-add-new-car">Select Brand</h3>
                <div className="search-container">
                  <input
                    type="text"
                    placeholder="Search brands..."
                    value={brandSearch}
                    onChange={(e) => setBrandSearch(e.target.value)}
                    className="search-input"
                  />
                </div>
              </div>
              {loading.brands ? (
                <div className="loading-message">Loading brands...</div>
              ) : error.brands ? (
                <div className="error-message">Error loading brands: {error.brands}</div>
              ) : (
                <div className="card-grid">
                  {filteredBrands.map(brand => (
                    <label
                      key={brand}
                      className={`selection-card ${formData.brand === brand ? 'selected' : ''}`}
                    >
                      <input
                        type="radio"
                        name="brand"
                        value={brand}
                        checked={formData.brand === brand}
                        onChange={handleChange}
                        required
                      />
                      <div className="card-content">
                        <div className="card-front">
                          <div className="card-icon">
                            {/* {getBrandIcon(brand)} */}
                          </div>
                          <span>{brand}</span>
                        </div>
                        <div className="card-back">
                          <span>{brand}</span>
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="form-step active">
            {loading.step2Data ? (
              <div className="loading-message">Loading vehicle options...</div>
            ) : error.step2Data ? (
              <div className="error-message">Error loading vehicle options: {error.step2Data}</div>
            ) : (
              <>
                <div className="form-section-add-new-car">
                  <h3 className="h3-add-new-car">Basic Information</h3>

                  {/* Add selected category and brand display */}
                  <div className="selected-info-display">
                    <div className="selected-info-item">
                      <span className="selected-info-label">Selected Category:</span>
                      <span className="selected-info-value">{formData.category}</span>
                    </div>
                    <div className="selected-info-item">
                      <span className="selected-info-label">Selected Brand:</span>
                      <span className="selected-info-value">{formData.brand}</span>
                    </div>
                  </div>

                  <div className="form-grid">

                    <div className="form-group-add-new-car">
                      <label htmlFor="model">Model*</label>
                      <input
                        type="text"
                        id="model"
                        name="model"
                        value={formData.model}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group-add-new-car">
                      <label htmlFor="price">Price ($)*</label>
                      <input
                        type="number"
                        id="price"
                        name="price"
                        min="0"
                        step="0.01"
                        value={formData.price}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form-group-add-new-car range-dropdown">
                      <label htmlFor="priceRange">Price Range*</label>
                      <select
                        id="priceRange"
                        name="priceRange"
                        value={formData.priceRange}
                        onChange={handleChange}
                        disabled
                        required
                        className="no-icon"
                      >
                        <option value="">Select Price Range</option>
                        {apiData.priceRanges.map(range => (
                          <option key={range} value={range}>{range}</option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group-add-new-car">
                      <label htmlFor="year">Year* <span>Range 1900 to Current Year</span></label>
                      <input
                        type="number"
                        id="year"
                        name="year"
                        min="1900"
                        max={new Date().getFullYear() + 1}
                        value={formData.year}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-subsection">
                    <h4>Identification Details</h4>
                    <div className="form-grid">
                      <div className="form-group-add-new-car">
                        <label htmlFor="refNumber">Reference Number*</label>
                        <input
                          type="text"
                          id="refNumber"
                          name="refNumber"
                          value={formData.refNumber}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="registrationDate">Registration Date*</label>
                        <input
                          type="date"
                          id="registrationDate"
                          name="registrationDate"
                          value={formData.registrationDate}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="manufactureDate">Manufacture Date*</label>
                        <input
                          type="date"
                          id="manufactureDate"
                          name="manufactureDate"
                          value={formData.manufactureDate}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="modelCode">Model Code*</label>
                        <input
                          type="text"
                          id="modelCode"
                          name="modelCode"
                          value={formData.modelCode}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="grade">Grade*</label>
                        <input
                          type="text"
                          id="grade"
                          name="grade"
                          value={formData.grade}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="chassisNumber">Chassis Number*</label>
                        <input
                          type="text"
                          id="chassisNumber"
                          name="chassisNumber"
                          value={formData.chassisNumber}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-subsection">
                    <h4>Engine & Transmission</h4>
                    <div className="form-grid">

                      <div className="form-group-add-new-car">
                        <label htmlFor="engineCC">Engine CC*</label>
                        <input
                          type="text"
                          id="engineCC"
                          name="engineCC"
                          value={formData.engineCC}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car range-dropdown">
                        <label htmlFor="engineCCRange">Engine CC Range*</label>
                        <select
                          id="engineCCRange"
                          name="engineCCRange"
                          value={formData.engineCCRange}
                          onChange={handleChange}
                          disabled
                          required
                          className="no-icon"
                        >
                          <option value="">Select Engine CC Range</option>
                          {apiData.engineCCRanges.map(range => (
                            <option key={range} value={range}>{range}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="engineCode">Engine Code*</label>
                        <input
                          type="text"
                          id="engineCode"
                          name="engineCode"
                          value={formData.engineCode}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="fuel">Fuel Type*</label>
                        <select
                          id="fuel"
                          name="fuel"
                          value={formData.fuel}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Fuel Type</option>
                          {apiData.fuels.map(fuel => (
                            <option key={fuel} value={fuel}>{fuel}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="transmission">Transmission*</label>
                        <select
                          id="transmission"
                          name="transmission"
                          value={formData.transmission}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Transmission</option>
                          {apiData.transmissions.map(trans => (
                            <option key={trans} value={trans}>{trans}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="steering">Steering*</label>
                        <select
                          id="steering"
                          name="steering"
                          value={formData.steering}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Steering</option>
                          {apiData.steeringOptions.map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="form-subsection">
                    <h4>Dimensions & Capacity</h4>
                    <div className="form-grid">

                      <div className="form-group-add-new-car">
                        <label htmlFor="seat">Seats*</label>
                        <input
                          type="number"
                          id="seat"
                          name="seat"
                          min="1"
                          value={formData.seat}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car range-dropdown">
                        <label htmlFor="seatRange">Seat Range*</label>
                        <select
                          id="seatRange"
                          name="seatRange"
                          value={formData.seatRange}
                          onChange={handleChange}
                          disabled
                          required
                          className="no-icon"
                        >
                          <option value="">Select Seat Range</option>
                          {apiData.seatRanges.map(range => (
                            <option key={range} value={range}>{range}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="doors">Doors*</label>
                        <input
                          type="number"
                          id="doors"
                          name="doors"
                          min="1"
                          value={formData.doors}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="mileage">Mileage (km)*</label>
                        <input
                          type="number"
                          id="mileage"
                          name="mileage"
                          min="0"
                          value={formData.mileage}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car range-dropdown">
                        <label htmlFor="mileageRange">Mileage Range*</label>
                        <select
                          id="mileageRange"
                          name="mileageRange"
                          value={formData.mileageRange}
                          onChange={handleChange}
                          disabled
                          required
                          className="no-icon"
                        >
                          <option value="">Select Mileage Range</option>
                          {apiData.mileageRanges.map(range => (
                            <option key={range} value={range}>{range}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="weight">Weight (kg)*</label>
                        <input
                          type="number"
                          id="weight"
                          name="weight"
                          min="0"
                          value={formData.weight}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-subsection">
                    <h4>Appearance & Features</h4>
                    <div className="form-grid">
                      <div className="form-group-add-new-car">
                        <label htmlFor="color">Color*</label>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <select
                            id="color"
                            name="color"
                            value={formData.color}
                            onChange={handleChange}
                            style={{ flex: 1 }}
                            required
                          >
                            <option value="">Select Color</option>
                            {apiData.colors.map(color => (
                              <option key={color} value={color}>{color}</option>
                            ))}
                          </select>
                          <button
                            type="button"
                            onClick={handleAddColorClick}
                            style={{
                              padding: '8px 12px',
                              backgroundColor: '#d10000',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '14px'
                            }}
                          >
                            Add New
                          </button>
                        </div>
                      </div>

                      {showAddColorDialog && (
                        <div className="dialog-overlay">
                          <div className="dialog-container">
                            <h3>Add New Color</h3>
                            <input
                              type="text"
                              value={newColor}
                              onChange={(e) => setNewColor(e.target.value)}
                              placeholder="Enter color name"
                              className="dialog-input"
                            />
                            <div className="dialog-buttons">
                              <button
                                type="button"
                                onClick={handleCancelAddColor}
                                className="dialog-button cancel"
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                onClick={handleSaveNewColor}
                                className="dialog-button save"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="form-group-add-new-car">
                        <label htmlFor="drive">Drive Type*</label>
                        <select
                          id="drive"
                          name="drive"
                          value={formData.drive}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Drive Type</option>
                          {apiData.driveType.map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="location">Location*</label>
                        <input
                          type="text"
                          id="location"
                          name="location"
                          value={formData.location}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="length">Length (meter)*</label>
                        <input
                          type="number"
                          id="length"
                          name="length"
                          min="0"
                          value={formData.length}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="width">Width (meter)*</label>
                        <input
                          type="number"
                          id="width"
                          name="width"
                          min="0"
                          value={formData.width}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="height">Height (meter)*</label>
                        <input
                          type="number"
                          id="height"
                          name="height"
                          min="0"
                          value={formData.height}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="form-group-add-new-car checkbox-group inline-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            name="ourPick"
                            checked={formData.ourPick}
                            onChange={handleChange}
                          />
                          Our Pick
                        </label>
                      </div>

                      <div className="form-group-add-new-car checkbox-group inline-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            name="specialDeal"
                            checked={formData.specialDeal}
                            onChange={handleChange}
                          />
                          Special Deal
                        </label>
                      </div>

                      <div className="form-group-add-new-car">
                        <label htmlFor="airConditioning">Air Conditioning Type*</label>
                        <input
                          type="text"
                          id="airConditioning"
                          name="airConditioning"
                          value={formData.airConditioning}
                          onChange={handleChange}
                          placeholder="Enter air conditioning details"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  {/* Shipping Options Section */}
                  {/* <div className="form-subsection">
                    <h4>Shipping Options & Fees</h4>
                    <div className="shipping-options-container">
                      {portFeeConfigs.length > 0 && (
                        <div className="shipping-fee-forms">
                          {portFeeConfigs.map((config) => (
                            <div key={config.shippingOptionName} className="shipping-fee-form">
                              <h5>{config.shippingOptionName} Fee Configuration</h5>
                              <div className="fee-inputs-grid">
                                {config.feeConfigurationList.map((fee) => (
                                  <div key={fee} className="form-group-add-new-car">
                                    <label
                                      htmlFor={`${config.shippingOptionName.toLowerCase()}-${fee
                                        .toLowerCase()
                                        .replace('_', '-')}`}
                                    >
                                      {fee.replace('_', ' ')} ($)
                                    </label>
                                    <input
                                      type="number"
                                      id={`${config.shippingOptionName.toLowerCase()}-${fee
                                        .toLowerCase()
                                        .replace('_', '-')}`}
                                      min="0"
                                      step="0.01"
                                      value={shippingFees[config.shippingOptionName][fee] || ''}
                                      onChange={(e) =>
                                        handleShippingFeeChange(
                                          config.shippingOptionName,
                                          fee,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div> */}
                  <div className="form-subsection">
  <h4>Shipping Options & Fees</h4>
  
  {portFeeConfigs.length > 0 && (() => {
    const uniqueFees = getAllUniqueFees();
    
    return (
      <div className="shipping-options-container">
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '200px repeat(3, 1fr)', 
          gap: '10px',
          alignItems: 'center'
        }}>
          {/* Header row */}
           <div style={{
              padding: '10px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #dee2e6',
              borderRadius: '4px',
              textAlign: 'center',
              fontWeight: 'bold',
              color: '#d32f2f'
            }}>
              Fee Type
           </div>

          {portFeeConfigs.map(config => (
            <div key={config.shippingOptionName} style={{
              padding: '10px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #dee2e6',
              borderRadius: '4px',
              textAlign: 'center',
              fontWeight: 'bold',
              color: '#d32f2f'
            }}>
              {config.shippingOptionName} Fee Configuration
            </div>
          ))}

          {/* Fee rows */}
          {uniqueFees.map(feeType => {
            const applicableOptions = getShippingOptionsForFee(feeType);
            
            return (
              <React.Fragment key={feeType}>
                {/* Fee label */}
                <div style={{
                  padding: '8px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #dee2e6',
                  borderRadius: '4px'
                }}>
                  {formatFeeLabel(feeType)} ($)
                </div>
                
                {/* Input fields for each shipping option */}
                {portFeeConfigs.map(config => {
                  const hasThisFee = applicableOptions.some(opt => 
                    opt.shippingOptionName === config.shippingOptionName
                  );
                  
                  return (
                    <div key={`${config.shippingOptionName}-${feeType}`}>
                      {hasThisFee ? (
                        // <input
                        //   type="number"
                        //   min="0"
                        //   step="0.01"
                        //   value={shippingFees[config.shippingOptionName]?.[feeType] || ''}
                        //   onChange={(e) =>
                        //     handleShippingFeeChange(
                        //       config.shippingOptionName,
                        //       feeType,
                        //       e.target.value
                        //     )
                        //   }
                        //   style={{
                        //     width: '100%',
                        //     padding: '8px 12px',
                        //     border: '1px solid #ced4da',
                        //     borderRadius: '4px',
                        //     fontSize: '14px',
                        //     boxSizing: 'border-box'
                        //   }}
                        //   placeholder="0.00"
                        // />
                        <input
  type="number"
  min="0"
  step="0.01"
  value={shippingFees[config.shippingOptionName]?.[feeType] || ''}
  onChange={(e) =>
    handleShippingFeeChange(
      config.shippingOptionName,
      feeType,
      e.target.value
    )
  }
  onFocus={() => handleFeeInputFocus(config.shippingOptionName, feeType)}
  style={{
    width: '100%',
    padding: '8px 12px',
    border: '1px solid #ced4da',
    borderRadius: '4px',
    fontSize: '14px',
    boxSizing: 'border-box'
  }}
  placeholder="0.00"
/>
                      ) : (
                        <div style={{
                          padding: '8px',
                          backgroundColor: '#f8f9fa',
                          border: '1px solid #dee2e6',
                          borderRadius: '4px',
                          color: '#6c757d',
                          textAlign: 'center',
                          fontSize: '14px'
                        }}>
                          N/A
                        </div>
                      )}
                    </div>
                  );
                })}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  })()}
</div>

                  <div className="form-subsection">
                    <h4>Accessories</h4>
                    <div className="form-group-add-new-car">
                      <label>Select Vehicle Main Accessories</label>
                      <div className="accessories-toggle-grid">
                        {apiData.vehicleAccessories.map(accessory => (
                          <div key={accessory} className="accessory-toggle-item">
                            <span className="accessory-label">{accessory}</span>
                            <label className="toggle-switch">
                              <input
                                type="checkbox"
                                value={accessory}
                                checked={formData.vehicleAccessories.includes(accessory)}
                                onChange={handleAccessoriesChange}
                              />
                              <span className="toggle-slider"></span>
                              <span className="toggle-yes">Yes</span>
                              <span className="toggle-no">No</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="form-group-add-new-car">
                      <label>Select Vehicle More Accessories</label>
                      <div className="accessories-toggle-grid">
                        {moreAccessories.map(accessory => (
                          <div key={accessory} className="accessory-toggle-item">
                            <span className="accessory-label">{accessory}</span>
                            <label className="toggle-switch">
                              <input
                                type="checkbox"
                                value={accessory}
                                checked={formData.moreAccessories.includes(accessory)}
                                onChange={handleMoreAccessoriesChange}
                              />
                              <span className="toggle-slider"></span>
                              <span className="toggle-yes">Yes</span>
                              <span className="toggle-no">No</span>
                            </label>
                          </div>
                        ))}
                      </div>

                      <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
                        <input
                          type="text"
                          value={newMoreAccessory}
                          onChange={(e) => setNewMoreAccessory(e.target.value)}
                          placeholder="Enter new accessory"
                          style={{ flex: 1 }}
                        />
                        <button
                          type="button"
                          onClick={handleSaveMoreAccessory}
                          style={{
                            padding: '8px 12px',
                            backgroundColor: '#d10000',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-section-add-new-car">
                  <h3 className="h3-add-new-car">Description</h3>
                  <div className="form-group-add-new-car">
                    <label htmlFor="modelDescription">Model Description*</label>
                    <textarea
                      id="modelDescription"
                      name="modelDescription"
                      rows="4"
                      value={formData.modelDescription}
                      onChange={handleChange}
                      placeholder="Enter model description..."
                      required
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {step === 3 && (
          <div className="form-step active">
            <div className="form-section-add-new-car">
              <h3 className="h3-add-new-car">Exterior Images (15 max)</h3>
              <div className="image-grid">
                {Array.from({ length: 15 }).map((_, index) => (
                  <div key={`exterior-${index}`} className="image-upload-box-add-new-car">
                    {previewImages.exterior[index] ? (
                      <div className="image-preview">
                        <img src={previewImages.exterior[index]} alt={`Exterior ${index + 1}`} />
                        <button
                          type="button"
                          className="remove-image-btn"
                          onClick={() => removeImage('exterior', index)}
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <label className="upload-label-add-new-car">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleImageUpload('exterior', index, e)}
                          style={{ display: 'none' }}
                        />
                        <span>+ Exterior {index + 1}</span>
                      </label>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="form-section-add-new-car">
              <h3 className="h3-add-new-car">Interior Images (15 max)</h3>
              <div className="image-grid">
                {Array.from({ length: 15 }).map((_, index) => (
                  <div key={`interior-${index}`} className="image-upload-box-add-new-car">
                    {previewImages.interior[index] ? (
                      <div className="image-preview">
                        <img src={previewImages.interior[index]} alt={`Interior ${index + 1}`} />
                        <button
                          type="button"
                          className="remove-image-btn"
                          onClick={() => removeImage('interior', index)}
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <label className="upload-label-add-new-car">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleImageUpload('interior', index, e)}
                          style={{ display: 'none' }}
                        />
                        <span>+ Interior {index + 1}</span>
                      </label>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="form-section-add-new-car">
              <h3 className="h3-add-new-car">Blueprint Image</h3>
              <div className="blueprint-upload">
                {previewImages.blueprint ? (
                  <div className="blueprint-preview">
                    <img src={previewImages.blueprint} alt="Blueprint" />
                    <button
                      type="button"
                      className="remove-image-btn"
                      onClick={() => removeImage('blueprint', 0)}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <label className="upload-label-add-new-car blueprint-label">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleImageUpload('blueprint', 0, e)}
                      style={{ display: 'none' }}
                    />
                    <span>+ Upload Blueprint</span>
                  </label>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="form-navigation">
          {step > 1 && (
            <button type="button" className="nav-btn prev-btn" onClick={prevStep}>
              Previous
            </button>
          )}
          {step === 3 ? (
            <button type="button" className="submit-btn" onClick={handleSubmit}>
              Submit Vehicle
            </button>
          ) : (
            <button type="button" className="nav-btn next-btn" onClick={nextStep}>
              Next
            </button>
          )}
        </div>
      </form>

      {/* Upload Confirmation Dialog */}
      {uploadState.showUploadDialog && (
        <div className="dialog-overlay">
          <div className="dialog-container">
            <h3>Confirm Image Upload</h3>
            <p>Are you sure you want to upload this image?</p>
            {uploadState.uploadError && (
              <div className="error-message">{uploadState.uploadError}</div>
            )}
            <div className="dialog-buttons">
              <button
                type="button"
                onClick={handleUploadCancel}
                className="dialog-button cancel"
                disabled={uploadState.isUploading}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleUploadConfirm}
                className="dialog-button save"
                disabled={uploadState.isUploading}
              >
                {uploadState.isUploading ? 'Uploading...' : 'Upload'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Save Confirmation Dialog */}
      {showSaveDialog && (
        <div className="dialog-overlay">
          <div className="dialog-container">
            <h3>Confirm Save</h3>
            <p>Are you sure you want to save this car model?</p>
            <div className="dialog-buttons">
              <button
                type="button"
                onClick={() => setShowSaveDialog(false)}
                className="dialog-button cancel"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSaveConfirm}
                className="dialog-button save"
                disabled={loading.apiCall}
              >
                {loading.apiCall ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Popup */}
      {showSuccessPopup && apiResponse && (
        <div className="success-popup-add-new-car">
          <div className="success-popup-content-add-new-car">
            <h3>CAR MODEL ADDED SUCCESSFULLY</h3>
            <p>Model Name: {apiResponse.carModelName}</p>
            <p>Request ID: {apiResponse.requestId}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddNewCar;